import type { IconProps } from '~/types'

export const AustraliaMapIcon = (props: IconProps) => {
  const { className = '' } = props
  return (
    <svg
      {...props}
      className={`${className}`}
      width="57px"
      height="54px"
      viewBox="0 0 57 54"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Australia@2x</title>
      <g id="Tucker-Tub---UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Our-Difference"
          transform="translate(-176.000000, -1486.000000)"
          stroke="#993955"
          strokeWidth="2.5"
        >
          <path
            d="M231.017392,1507.90589 C228.880502,1509.62106 225.513735,1499.92734 222.338433,1499.62663 C221.398382,1499.05462 219.75692,1489.42622 218.861168,1494.33021 C218.371871,1495.11784 218.394897,1488.57752 216.508536,1488 C214.255641,1490.06906 215.520556,1495.95002 213.425087,1497.3626 C205.176609,1492.46199 208.182972,1495.63592 208.67665,1490.14027 C207.455158,1490.34412 203.423022,1488.33412 203.471952,1489.37742 C203.967507,1491.1927 200.109315,1488.71029 199.182028,1493.79023 C198.523792,1493.51092 197.743794,1494.75681 197.53944,1493.65858 C194.631437,1489.3365 191.921531,1497.18377 191.469775,1496.76243 C189.616827,1493.72065 190.309102,1499.17963 188.726581,1499.47671 C185.798556,1501.2308 182.065755,1501.18538 179.566584,1503.70006 C179.043749,1504.1781 179.311674,1502.96424 178.854663,1503.04533 C177.066913,1506.438 180.49262,1511.52181 178.059523,1508.81316 C177.398283,1510.40582 182.506498,1517.72801 180.534667,1522.02081 C188.630349,1527.10575 200.529911,1510.11036 207.112275,1522.31501 C207.814435,1524.37382 209.392075,1521.29325 210.014521,1520.5359 C210.475162,1520.03972 210.296587,1522.97976 209.707303,1523.14719 C209.002639,1523.29799 209.379811,1523.83822 209.95508,1523.58356 C210.770242,1522.38196 211.893248,1521.50761 211.191213,1523.80756 C212.736817,1525.05908 213.788994,1528.19597 216.000092,1529.52007 C218.028612,1531.56261 220.644288,1526.42574 219.89933,1529.21298 C220.835502,1528.76573 221.407642,1529.95056 222.057619,1530.34112 C221.479848,1527.97973 227.027554,1528.10236 226.887773,1527.24816 C228.567777,1516.57322 232.507685,1521.21403 231.017392,1507.90589 Z M220.494208,1533.11422 C217.688444,1531.60478 221.9402,1543.63274 224.501816,1534.61678 C224.907395,1531.81727 221.834207,1534.37175 220.494208,1533.11422 Z"
            id="Australia"
          />
        </g>
      </g>
    </svg>
  )
}
